const ICON_PLUS =
  '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 9 9"><path fill="currentColor" d="M4 0h1v9H4z"/><path fill="currentColor" d="M0 4h9v1H0z"/></svg>'

function FacetAccordion (params, index) {
  if (!params) {
    return ''
  }

  const props = {
    field: params.field || '',
    name: params.name || '',
    type: params.type || '',
    values: params.data || [],
    id: params.id || '',
    index: index || 0,
    min: params.min,
    max: params.max,
  }

  props.activeCount = props.values.filter((data) => data.selected)?.length || 0

  if (props.field === 'price') {
    const urlParams = new URLSearchParams(window.location.search)
    props.activeCount = urlParams.has('price') ? 1 : 0
  }

  let innerTemplate = ''

  if (
    window.theme.nosto.priceFacets.includes(props.field) ||
    window.theme.nosto.priceFacets.includes(props.type)
  ) {
    innerTemplate = renderPriceFacet(props)
  } else if (window.theme.nosto.colourFacets.includes(props.field)) {
    innerTemplate = renderColourFacet(props)
  } else {
    const sizeFacet = window.theme.nosto.sizeFacets.includes(props.field)
    innerTemplate = renderDefaultFacet(props, sizeFacet)
  }

  const id = `facet-${props.field}`

  const propName = props.name

  return `
    <div class="drw-ProductGridFacets_Item">
      <button
        class="drw-ProductGridFacets_Trigger fz-14_140"
        type="button"
        aria-controls="${id}"
        data-accordion-group-el="trigger"
        aria-expanded="${props.activeCount ? 'true' : 'false'}"
        data-results-filters-el="facet"
        data-index="${id}"
      >
        ${propName}
        ${props.activeCount ? `(${props.activeCount})` : ''}

        <span class="drw-ProductGridFacets_TriggerIcon">
          ${ICON_PLUS}
        </span>
      </button>

      <div
        id="${id}"
        class="drw-ProductGridFacets_Accordion"
        aria-hidden="${props.activeCount ? 'false' : 'true'}"
        data-accordion-group-el="content"
        data-results-filters-el="facet"
        data-index="results-${props.index}-content"
      >
        <div class="drw-ProductGridFacets_AccordionContent">
          ${innerTemplate}
        </div>
      </div>
    </div>
  `
}

function renderPriceFacet (params) {
  const priceParam = new URLSearchParams(window.location.search).get('price')
  let activeMin = null
  let activeMax = null

  if (priceParam) {
    const parts = priceParam.split('~')
    if (parts.length === 2) {
      const parsedMin = parseFloat(parts[0])
      const parsedMax = parseFloat(parts[1])
      if (Number.isFinite(parsedMin) && Number.isFinite(parsedMax)) {
        activeMin = parsedMin
        activeMax = parsedMax
      }
    }
  }

  let boundsMin = Math.floor(params.min ?? 0)
  const boundsMax = Math.ceil(params.max ?? 0)

  if (!Number.isFinite(boundsMin) || boundsMin < 0) {
    boundsMin = 0
  }

  if (boundsMax < boundsMin) {
    boundsMin = boundsMax
  }

  if (activeMin !== null) {
    activeMin = Math.min(Math.max(activeMin, boundsMin), boundsMax)
  }

  if (activeMax !== null) {
    activeMax = Math.min(Math.max(activeMax, boundsMin), boundsMax)
  }

  if (activeMin !== null && activeMax !== null && activeMin > activeMax) {
    const t = activeMin
    activeMin = activeMax
    activeMax = t
  }

  const props = {
    max: boundsMax,
    maxValue: activeMax || '',
    min: boundsMin,
    minValue: activeMin || '',
    name: params.name || '',
  }

  const format = window.theme.moneyFormat.replace(
    'amount',
    'amount_no_decimals',
  )

  props.maxFormatted = props.maxValue
    ? window.BAO.Utils.formatMoney(props.maxValue * 100, format)
    : window.BAO.Utils.formatMoney(props.max * 100, format)

  props.minFormatted = window.BAO.Utils.formatMoney(
    props.minValue * 100,
    format,
  )

  return `
    <range-slider
      class="clc-PriceRange"
      min="0"
      max="${props.max}"
      ${props.minValue ? `min-value="${props.minValue}` : ''}
      ${props.maxValue ? `max-value="${props.maxValue}` : ''}
    >
      <div class="clc-PriceRange_Slider">
        <button
          class="clc-PriceRange_Dot clc-PriceRange_Dot-left"
          type="button"
          tabindex="-1"
          aria-hidden="true"
          aria-label="${props.minFormatted}"
          data-range-slider-el="touchLeft"
        >
          <span class="clc-PriceRange_Arrow">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 8">
              <path fill="currentColor" d="M0 8V0l5.38 3.584a.5.5 0 0 1 0 .832z"/>
            </svg>
          </span>
        </button>

        <button
          class="clc-PriceRange_Dot clc-PriceRange_Dot-right"
          type="button"
          tabindex="-1"
          aria-hidden="true"
          aria-label="${props.maxFormatted}"
          data-range-slider-el="touchRight"
          style="right: 0%;"
        >
          <span class="clc-PriceRange_Arrow">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 8">
              <path fill="currentColor" d="M5.602 8V0L.222 3.584a.5.5 0 0 0 0 .832z"/>
            </svg>
          </span>
        </button>

        <div class="clc-PriceRange_Line" data-range-slider-el="line">
          <span class="clc-PriceRange_LineInner"></span>
          <span class="clc-PriceRange_LineHighlighter" data-range-slider-el="highlighter"></span>
        </div>
      </div>

      <div class="clc-PriceRange_Fields">
        <div class="clc-PriceRange_Field">
          <label class="clc-PriceRange_Label fz-14_140 util-ScreenReaderOnly" for="price-min">
            ${window.theme.strings.sections.collectionTemplate.priceRange.minimum}
          </label>

          <input
            class="clc-PriceRange_Input clc-PriceRange_Input-min fz-14_140"
            id="price-min"
            type="text"
            value="${props.minFormatted}"
            placeholder="${props.minFormatted}"
            aria-label="${window.theme.strings.accessibility.priceRange.minimum.replace('[value]', props.minFormatted)}"
            data-range-slider-el="minFormatted"
          >
        </div>

        <div class="clc-PriceRange_Field">
          <label class="clc-PriceRange_Label fz-14_140 util-ScreenReaderOnly" for="price-max">
            ${window.theme.strings.sections.collectionTemplate.priceRange.maximum}
          </label>

          <input
            class="clc-PriceRange_Input clc-PriceRange_Input-max fz-14_140"
            id="price-max"
            type="text"
            value="${props.maxFormatted}"
            placeholder="${props.maxFormatted}"
            aria-label="${window.theme.strings.accessibility.priceRange.maximum.replace('[value]', props.maxFormatted)}"
            data-range-slider-el="maxFormatted"
          >
        </div>
      </div>

      <input
        id="results-price-GTE"
        class="clc-PriceRange_Input"
        name="results-price-min"
        value="${props.minValue || props.min}"
        type="hidden"
        placeholder="0"
        min="0"
        max="${props.maxValue}"
        data-range-slider-el="min"
        data-results-filters-el="min"
      >

      <input
        id="results-price-LTE"
        class="clc-PriceRange_Input"
        name="results-price-max"
        value="${props.maxValue || props.max}"
        type="hidden"
        min="${props.minValue ? props.minValue : 0}"
        placeholder="${props.max}"
        max="${props.max}"
        data-range-slider-el="max"
        data-results-filters-el="max"
      >
    </range-slider>
  `
}

function renderColourFacet (props) {
  const valuesTemplate = props.values
    .map((value, index) => {
      const id = `results-${props.field}-${index}`
      const handle = value.value.toLowerCase().trim().replaceAll(' ', '-')

      return `
        <li class="clc-ProductGridFacet_Item">
          <label
            class="clc-ProductGridFacet_Label clc-ProductGridFacet_Label-swatch fz-13_140"
            for="${id}"
            aria-disabled="${value.count === 0 && !value.selected ? 'true' : 'false'}"
          >
            <input
              id="${id}"
              class="clc-ProductGridFacet_Checkbox util-ScreenReaderOnly"
              type="checkbox"
              name="${props.field}"
              value="${value.value}"
              ${value.selected ? 'checked' : ''}
              ${value.count === 0 && !value.selected ? 'disabled' : ''}
            >

            ${value.value}
            (${value.count})

            <span class="clc-ProductGridFacet_Swatch col-Color-${handle}"></span>
          </label>
        </li>
      `
    })
    .join('')

  return `
    <ul class="clc-ProductGridFacet_Items">
      ${valuesTemplate}
    </ul>
  `
}

function renderDefaultFacet (props, sizeFacet) {
  const valuesTemplate = props.values
    .map((value, index) => {
      const id = `results-${props.field}-${index}`

      return `
        <li class="clc-ProductGridFacet_Item">
          <label
            class="clc-ProductGridFacet_Label fz-13_140"
            for="${id}"
            aria-disabled="${value.count === 0 && !value.selected ? 'true' : 'false'}"
          >
            <input
              id="${id}"
              class="clc-ProductGridFacet_Checkbox util-ScreenReaderOnly"
              type="checkbox"
              name="${props.field}"
              value="${value.value}"
              ${value.selected ? 'checked' : ''}
              ${value.count === 0 && !value.selected ? 'disabled' : ''}
            >

            ${value.value}
          </label>
        </li>
      `
    })
    .join('')

  return `
    <ul class="clc-ProductGridFacet_Items${sizeFacet ? ' clc-ProductGridFacet_Items-fourCol' : ''}">
      ${valuesTemplate}
    </ul>
  `
}

window.templates.FacetAccordion = FacetAccordion
